import React from "react";

const defaults = {};

export const EnvContext = React.createContext(defaults);

export function useEnv() {
  return React.useContext(EnvContext);
}
